import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import RaikoBaseContainer from "../../raikoComponents/raikoBaseContainer/RaikoBaseContainer";
import RaikoBreadcrumb, {
    raikoBreadCrumbItemGenerator
} from "../../raikoComponents/raikoBreadcrumbCustom/RaikoBreadcrumb";
import {RouteInfo} from "../../route/RouteHelper";
import React, {useState} from "react";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import {Helmet} from "react-helmet";
import {css} from "@emotion/css";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import RaikoCustomTable from "../../raikoComponents/raikoCustomTable/RaikoCustomTable";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import {RaikoCustomSimpleChip} from "../../raikoComponents/raikoCustomChip/raikoCustomSimpleChip/RaikoCustomSimpleChip";
import {RaikoChipTypes} from "../../raikoComponents/raikoCustomChip/RaikoChipTypes";
import RaikoDefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/RaikoDefaultDialogPage";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import AddNewGallery from "./AddNewGallery";
import {navigate} from "@storybook/addon-links";
import {useNavigate} from "react-router-dom";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";

const Galleries = () => {
    const [galleriesData, setGalleriesData] = useState([
        prepareTableRow(1, 1, 1, 1, 1, "2023/01/01", true)
    ])
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()

    function prepareTableRow(id, number, thumbnail, title, createdBy, createdAt, published) {
        return {
            id,
            number,
            thumbnail,
            title,
            createdBy,
            createdAt: convertUniversalDateToPersianDate(createdAt),
            published: published ? <RaikoCustomSimpleChip title={"منتشر شده"} type={RaikoChipTypes.success}/> :
                <RaikoCustomSimpleChip title={"منتشر نشده"} type={RaikoChipTypes.error}/>
        }

    }

    function handleShowGalleryDetail(rowId) {
        navigate(RouteInfo.GalleryDetail.globalUrl.replace(":id", rowId))
    }

//
    const [openDialog, setOpenDialog] = useState(false)

    function handleOpenDialog() {
        setOpenDialog(true)
    }

    function handleCloseDialog() {
        setOpenDialog(false)
    }

    return (
        <>
            <Helmet>
                <title>{RouteInfo.Galleries.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                pageTitle={"افزودن گالری جدید"}
                dialogSize={DialogSize.WRAP_CONTENT}
            >
                <AddNewGallery/>
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer className={css`
              padding: 26px 0;
              overflow: hidden;
            `}>
                <RaikoGridOneColumn>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                "چند رسانه ای",
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteInfo.Galleries.name,
                                ""
                            ),
                        ]}/>
                    <RaikoBaseCardContainer>
                        <ButtonDivisionSection>
                            <ButtonPrimaryRaiko
                                onClick={handleOpenDialog}
                                label={"افزودن"}/>
                        </ButtonDivisionSection>

                        <RaikoCustomTable
                            isLoading={isLoading}
                            data={galleriesData}
                            header={tableHeader}
                            rowClicked={handleShowGalleryDetail}
                        />
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>

            </RaikoBaseContainer>


        </>
    )
}
export default Galleries;
// function handleShowManagerInfo(rowId) {
//     navigate(`${RouteInfo.ManagersDetail.globalUrl.replace(":id", rowId)}`)
// }
const tableHeader = [
    {
        id: 'number',
        label: '#',
    },
    {
        id: 'thumbnail',
        label: 'عکس شاخص'
    },
    {
        id: 'title',
        label: 'عنوان',
    },
    {
        id: 'createdBy',
        label: 'ساخته شده توسط'
    },
    {
        id: 'createdAt',
        label: 'تاریخ انتشار'
    },
    {
        id: 'published',
        label: 'وضعیت انتشار',
    }
]